import React from 'react';
import SKetchup from '../assets/img/sketchup.svg'
import RulerW from '../assets/img/ruler_white.png'
import RulerB from '../assets/img/ruler_black.png'
import EdgeLogoFR from '../assets/img/logo-edge_fr.png';
import EdgeLogoEN from '../assets/img/logo-edge_en.png';
import { useTranslation } from 'react-i18next';

export default function ActionButtons({ collection, dimensions, setDimensions, iframe }) {
    const { i18n, t } = useTranslation();
    function setAllDimensions(e) {
        setDimensions(e)
        iframe.showHideMeasures(e);
    }
    return (
        <div className="fixed z-[2] w-[calc(100%-30px)] md:w-full bottom-4 left-1/2 transform -translate-x-1/2 flex flex-col-reverse gap-4 justify-start md:flex-row md:gap-0 ">
            <div className='mx-auto w-auto col-span-8 flex flex-row px-4 justify-center bg-[#000]'>
                <img className='w-[22px]' src={SKetchup} alt='fr_logo' />
                <button
                    className="text-white py-2 px-2 md:px-4 rounded lowercase font-NeueMTL font-light"
                    onClick={() => window.open(collection.link, "_blank")}
                >
                    {t("downloadSketchup")}
                </button>
            </div>
            <div
                onClick={() => setAllDimensions(!dimensions)}
                className={`absolute cursor-pointer left-0 md:left-5 bottom-0 w-auto col-span-8 flex flex-row p-2 border border-black justify-center ${dimensions ? "bg-[#000]" : "bg-[#fff]"}`}
            >
                <img className='w-[24px]' src={dimensions ? RulerW : RulerB} alt='ruler' />
            </div>
            {/* ------------ Edge LOGO ----------- */}
            <div className="my-auto md:absolute md:right-5 md:bottom-0 ml-auto col-span-4">
                <a href="https://www.edgedimension.com" target="_blank" rel="noopener noreferrer">
                    <img src={i18n.language === "fr" ? EdgeLogoFR : EdgeLogoEN} className='w-[68px] h-[22px] opacity-25 hover:opacity-100 transition-opacity' alt='Edge Logo' />
                </a>
            </div>
        </div>
    );
}
